module.exports = __webpack_public_path__ + "img/grid1.34ddb86.png";